<div class="data-block data-block--block-labels" *ngIf="hasServices || editModeSet; else placeholder">
  <div class="data-block__item">
    <div class="data-block__label">Fuel:</div>
    <div class="data-block__value">
      <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Fuel::').length > 0; else FAAPlaceholder">
        <div class="data-block__value">
          <div class="data-list">
            <app-data-item [source]="5" [compact]="true">
              <mat-icon
                (click)="openEditTagsDialog(['Fuel::'], null, 'Fuel')"
                *ngIf="editModeSet && isIslandSource" class="edit-icon" mat-tooltip="Edit" aria-label="Edit fuel">edit</mat-icon>
              {{getSubTags(this.airport.airportTags,'Fuel::')}}
              <ng-container *ngIf="editModeSet && getSubTags(this.airport.airportTags,'Fuel::').length < 1">
                None
              </ng-container>
            </app-data-item>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Engine Repair:</div>
    <div class="data-block__value">
      <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Services::Engine Repair::').length > 0; else FAAPlaceholder">
        <div class="data-block__value">
          <div class="data-list">
            <app-data-item [source]="5" [compact]="true">
              <mat-icon
                (click)="openEditTagsDialog(['Services::Engine Repair::'], null, 'Engine Repair')"
                *ngIf="editModeSet && isIslandSource" class="edit-icon" mat-tooltip="Edit" aria-label="Edit engine repair">edit</mat-icon>
              {{getSubTags(this.airport.airportTags,'Services::Engine Repair::')}}
              <ng-container *ngIf="editModeSet && getSubTags(this.airport.airportTags,'Services::Engine Repair::').length < 1">
                None
              </ng-container>
            </app-data-item>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Airframe Repair:</div>
    <div class="data-block__value">
      <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Services::Airframe Repair::').length > 0; else FAAPlaceholder">
        <div class="data-block__value">
          <div class="data-list">
            <app-data-item [source]="5" [compact]="true">
              <mat-icon
                (click)="openEditTagsDialog(['Services::Airframe Repair::'], null, 'Airframe Repair')"
                *ngIf="editModeSet && isIslandSource" class="edit-icon" mat-tooltip="Edit" aria-label="Edit airframe repair">edit</mat-icon>
              {{getSubTags(this.airport.airportTags,'Services::Airframe Repair::')}}
              <ng-container *ngIf="editModeSet && getSubTags(this.airport.airportTags,'Services::Airframe Repair::').length < 1">
                None
              </ng-container>
            </app-data-item>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Bottled Oxygen:</div>
    <div class="data-block__value">
      <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Services::Bottled Oxygen::').length > 0; else FAAPlaceholder">
        <div class="data-block__value">
          <div class="data-list">
            <app-data-item [source]="5" [compact]="true">
              <mat-icon
                (click)="openEditTagsDialog(['Services::Bottled Oxygen::'], null, 'Bottled Oxygen')"
                *ngIf="editModeSet && isIslandSource" class="edit-icon" mat-tooltip="Edit" aria-label="Edit bottled oxygen">edit</mat-icon>
              {{getSubTags(this.airport.airportTags,'Services::Bottled Oxygen::')}}
              <ng-container *ngIf="editModeSet && getSubTags(this.airport.airportTags,'Services::Bottled Oxygen::').length < 1">
                None
              </ng-container>
            </app-data-item>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Bulk Oxygen:</div>
    <div class="data-block__value">
      <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Services::Bulk Oxygen::').length > 0; else FAAPlaceholder">
        <div class="data-block__value">
          <div class="data-list">
            <app-data-item [source]="5" [compact]="true">
              <mat-icon
                (click)="openEditTagsDialog(['Services::Bulk Oxygen::'], null, 'Bulk Oxygen')"
                *ngIf="editModeSet && isIslandSource" class="edit-icon" mat-tooltip="Edit" aria-label="Edit bulk oxygen">edit</mat-icon>
              {{getSubTags(this.airport.airportTags,'Services::Bulk Oxygen::')}}
              <ng-container *ngIf="editModeSet && getSubTags(this.airport.airportTags,'Services::Bulk Oxygen::').length < 1">
                None
              </ng-container>
            </app-data-item>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Customs:</div>
    <div class="data-block__value">
      <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Customs::').length > 0; else FAAPlaceholder">
        <div class="data-block__value">
          <div class="data-list">
            <app-data-item [source]="5" [compact]="true">
              <mat-icon
                (click)="openEditTagsDialog(['Customs::'], null, 'Customs')"
                *ngIf="editModeSet && isIslandSource" class="edit-icon" mat-tooltip="Edit" aria-label="Edit customs">edit</mat-icon>
              {{getSubTags(this.airport.airportTags,'Customs::')}}
              <ng-container *ngIf="editModeSet && getSubTags(this.airport.airportTags,'Customs::').length < 1">
                None
              </ng-container>
            </app-data-item>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Transportation:</div>
    <div class="data-block__value">
      <div class="data-list">
        <app-data-item [source]="5" [compact]="true">
          <mat-icon
            (click)="openEditTagsDialog(['Transportation::'], null, 'Transportation')"
            *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit activities">edit</mat-icon>
          {{getSubTags(this.airport.airportTags,'Transportation::')}}
          <ng-container *ngIf="getSubTags(this.airport.airportTags,'Transportation::').length < 1">
            None Reported
          </ng-container>
        </app-data-item>
      </div>
    </div>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Activities:</div>
    <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Activities::').length > 0; else activityPlaceholder">
      <div class="data-block__value">
        <div class="data-list">
          <app-data-item [source]="5" [compact]="true">
            <mat-icon
              (click)="openEditTagsDialog(['Activities::'], null, 'Activities')"
              *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit activities">edit</mat-icon>
            {{getSubTags(this.airport.airportTags,'Activities::')}}
            <ng-container *ngIf="editModeSet && getSubTags(this.airport.airportTags,'Activities::').length < 1">
              None Reported
            </ng-container>
          </app-data-item>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="data-block__item">
    <div class="data-block__label">Camping On Field:</div>
    <ng-container *ngIf="editModeSet || getSubTags(this.airport.airportTags,'Camping On Field').length > 0; else activityPlaceholder">
      <div class="data-block__value">
        <div class="data-list__camping">
          <app-data-item [source]="5" [compact]="true">
            <mat-icon
              (click)="openEditCampingDialog()"
              *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit activities">edit</mat-icon>
            <ng-container *ngIf="getCampingOnFieldText().length > 0">
              {{getCampingOnFieldText()}}
            </ng-container>
            <ng-container *ngIf="getCampingAvailabilityText().length > 0">
              <b>Availability:</b> {{getCampingAvailabilityText()}}
            </ng-container>
            <ng-container *ngIf="getSubTags(this.airport.airportTags,'Camping On Field::Facilities::').length > 0">
              <br><br><b>Facilities:</b> {{getSubTags(this.airport.airportTags,'Camping On Field::Facilities::')}}
            </ng-container>
          </app-data-item>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">No services are available at this airport.</div>
  </div>
</ng-template>
<ng-template #FAAPlaceholder>None</ng-template>
<ng-template #activityPlaceholder>
  <div class="data-block__value">None Reported</div>
</ng-template>
<ng-template #generalPlaceholder>None reported</ng-template>
